'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# Advertisement
A basic Advertisement.
 */
var Advertisement = function Advertisement(_ref) {
  var image = _ref.image,
      imageDescription = _ref.imageDescription,
      link = _ref.link;

  if (link) {
    return _react2.default.createElement(
      'a',
      {
        href: link,
        target: '_blank',
        rel: 'noopener noreferrer'
      },
      _react2.default.createElement('img', {
        src: image,
        alt: imageDescription
      })
    );
  }

  return _react2.default.createElement('img', {
    src: image,
    alt: imageDescription
  });
};

Advertisement.propTypes = {
  /** advertisement image */
  image: _propTypes2.default.string.isRequired,
  /** advertisement image alt text */
  imageDescription: _propTypes2.default.string.isRequired,
  /** link that opens after clicking advertisement */
  link: _propTypes2.default.string
};

Advertisement.defaultProps = {
  link: ''
};

Advertisement.displayName = 'Advertisement';

exports.default = Advertisement;
Advertisement.__docgenInfo = {
  'description': '# Advertisement\r\nA basic Advertisement.',
  'methods': [],
  'displayName': 'Advertisement',
  'props': {
    'link': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'link that opens after clicking advertisement'
    },
    'image': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'advertisement image'
    },
    'imageDescription': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'advertisement image alt text'
    }
  }
};